export { default } from "./src/video";

export type { UniformVideoProps } from "./src/video";
